import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { AlertTriangle, ArrowRight, X } from "lucide-react";
import { useState } from "react";

// Iter122de · Banner GDPR per admin dei nuovi Studi quando il Titolare del trattamento
// è incompleto. Sparisce quando la lista `titolare_mancanti` diventa vuota (dopo il salvataggio
// dei dati in Impostazioni → refresh /auth/me), oppure quando l'admin lo chiude per la sessione.
export function TitolareBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  if (!user || user.role !== "admin") return null;
  const mancanti = user.titolare_mancanti || [];
  if (mancanti.length === 0 || dismissed) return null;
  const critici = mancanti.filter((m) => ["ragione_sociale", "pec", "indirizzo"].includes(m.key));
  const isCritico = critici.length > 0;
  return (
    <div
      data-testid="titolare-banner"
      className={`rounded-xl border-2 p-4 mb-4 flex items-start gap-3 ${
        isCritico ? "border-red-300 bg-red-50" : "border-amber-300 bg-amber-50"
      }`}
    >
      <AlertTriangle className={`w-6 h-6 shrink-0 mt-0.5 ${isCritico ? "text-red-700" : "text-amber-700"}`} />
      <div className="flex-1 min-w-0 text-sm">
        <div className={`font-bold text-base ${isCritico ? "text-red-800" : "text-amber-900"}`}>
          Completa il Profilo Studio · Titolare del trattamento
        </div>
        <p className="text-slate-700 mt-1">
          Ai sensi del Regolamento UE 2016/679 (GDPR) i condòmini e i fornitori devono poter identificare
          il Titolare del trattamento dei propri dati (il Suo Studio). Ci sono ancora <b>{mancanti.length}</b> {mancanti.length === 1 ? "campo" : "campi"} da compilare:{" "}
          <span className="font-semibold">
            {mancanti.slice(0, 5).map((m) => m.label).join(" · ")}
            {mancanti.length > 5 ? "…" : ""}
          </span>
        </p>
        <div className="mt-3 flex flex-wrap gap-2 items-center">
          <Link
            to="/impostazioni"
            data-testid="titolare-banner-cta"
            className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-lg font-semibold text-white text-sm ${
              isCritico ? "bg-red-700 hover:bg-red-800" : "bg-amber-700 hover:bg-amber-800"
            }`}
          >
            Vai al Profilo Studio <ArrowRight className="w-4 h-4" />
          </Link>
          {!isCritico && (
            <button
              type="button"
              data-testid="titolare-banner-dismiss"
              onClick={() => setDismissed(true)}
              className="text-sm text-slate-500 hover:text-slate-700 inline-flex items-center gap-1"
            >
              <X className="w-4 h-4" /> Ricordamelo dopo
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
